import { render, staticRenderFns } from "./ModalVisualizarSancoes.vue?vue&type=template&id=e91382dc&scoped=true&lang=pug"
import script from "./ModalVisualizarSancoes.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarSancoes.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarSancoes.vue?vue&type=style&index=0&id=e91382dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91382dc",
  null
  
)

export default component.exports